

















































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { STATUSES as SERVICE_CANDIDATE_STATUSES } from '@/constants/service_candidate';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import _ from 'lodash';
import BookingReport from '@/pages/Admin/Booking/BookingReport.vue';
import QUserSignature from '@/components/QUserSignature.vue';
import QDownloadBtn from '@/components/QDownloadBtn.vue';

@Component({
  components: {
    BookingReport,
    QUserSignature,
    QDownloadBtn,
  },
  computed: {
    ...mapState('Auth', {
      user: 'user',
    }),
    ...mapState('ServiceCandidate', {
      activeServiceCandidate: 'activeServiceCandidate',
    }),
    ...mapState('QuestionnaireAnswer', {
      questionnaireAnswer: 'questionnaireAnswer',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
  },
})
export default class ServiceCandidateRead extends Vue {
  @Prop({ default: false }) readonly needMarginTop!: boolean;
  @Ref() readonly qUserSignature!: QUserSignature;
  @Ref() readonly bottomSheetQUserSignature!: QUserSignature;

  reload = 0;

  questionnaireAnswer!: Model;
  booking!: Model;

  isMounted = false;
  isLoading = false;
  isSubmit = false;

  user!: Model;
  activeServiceCandidate!: ServiceCandidate;
  tmpServiceCandidate = {
    service_comment: {
      comment: '',
      signature_image: undefined,
      response_to_business_message: '',
    },
  };
  serviceCandidateStatuses = SERVICE_CANDIDATE_STATUSES;
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;

  serviceItems!: Model[];

  isApiFetch = {
    isApiFetchserviceCandidateFinished: false,
  };

  showResult = false;
  showComment = false;
  showConfirm = false;

  originalComment = '';
  commentSaved = true;
  commentInvalid = false;
  tmpSignaturePadRawData: undefined | string = '';

  beforeMount() {
    this.init();
  }

  async init() {
    this.isApiFetch = {
      isApiFetchserviceCandidateFinished: false,
    };

    let oid;
    if (this.activeServiceCandidate) {
      oid = this.activeServiceCandidate.object_id;
    }
    if (this.$route.params.serviceCandidateOid) {
      oid = this.$route.params.serviceCandidateOid;
    }
    this.$store.dispatch('ServiceCandidate/fetch', oid).then(() => {
      this.isApiFetch['isApiFetchserviceCandidateFinished'] = true;
    });
  }

  @Watch('showComment')
  watchShowComment() {
    this.reload++;
    this.syncSignaturePadRawData();
  }

  syncSignaturePadRawData() {
    if (this.bottomSheetQUserSignature) {
      console.debug('sync');
      const {
        signature_pad_raw_data,
      } = this.bottomSheetQUserSignature.getSignature();
      this.tmpSignaturePadRawData = signature_pad_raw_data;
    }
  }

  @Watch('activeServiceCandidate', { deep: true })
  watchActiveServiceCandidate(v) {
    this.tmpServiceCandidate = _.cloneDeep(v);
  }

  @Watch('tmpServiceCandidate', { deep: true })
  watchTmpServiceCandidate(v) {
    if (
      v.service_comment.comment === this.originalComment ||
      (_.isEmpty(v.service_comment.comment) && _.isEmpty(this.originalComment))
    ) {
      this.commentSaved = true;
    } else {
      this.commentSaved = false;
    }
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }

      if (!isFinished) {
        return;
      }

      if (
        !this.booking ||
        this.booking.object_id !=
          this.activeServiceCandidate.booking_candidate.booking.object_id
      ) {
        this.$store.commit('Booking/SET_STATE', {
          key: 'booking',
          payload: this.activeServiceCandidate.booking_candidate.booking,
        });
      }

      if (
        !this.questionnaireAnswer ||
        (this.questionnaireAnswer &&
          this.activeServiceCandidate.booking_candidate.questionnaire_answer &&
          this.questionnaireAnswer.object_id !=
            this.activeServiceCandidate.booking_candidate.questionnaire_answer
              .object_id)
      ) {
        this.$store.commit(
          'QuestionnaireAnswer/SET_QUESTIONNAIRE_ANSWER',
          this.activeServiceCandidate.booking_candidate.questionnaire_answer
        );
      }

      this.tmpServiceCandidate = _.cloneDeep(this.activeServiceCandidate);
      this.originalComment = this.activeServiceCandidate.service_comment.comment;

      this.isMounted = true;
      this.isLoading = false;
      this.isSubmit = false;
    }
  }

  canPickup() {
    return (
      !this.activeServiceCandidate.pickup_by_user &&
      this.activeServiceCandidate.status ==
        this.serviceCandidateStatuses.STATUS_ONGOING.key &&
      this.activeServiceCandidate.booking_candidate.status ==
        this.bookingCandidateStatuses.STATUS_COMPLETED.key
    );
  }

  pickup() {
    this.isLoading = true;
    this.$store
      .dispatch(
        'ServiceCandidate/pickup',
        this.activeServiceCandidate.object_id
      )
      .then(() => {
        this.init();
      })
      .catch(({ response }) => {
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: response.data.error,
        });
        this.isLoading = false;
      });
  }

  async comment() {
    this.isSubmit = true;

    return this.$store
      .dispatch('ServiceCandidate/comment', this.tmpServiceCandidate)
      .then(async () => {
        await this.init();
        this.commentSaved = true;
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'success',
          message: 'Save your comment successfully!',
        });
        this.reload++;
        return true;
      })
      .catch(({ response }) => {
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: response.data.error,
        });
        this.isSubmit = false;
        return false;
      });
  }

  get candidateName() {
    if (
      !this.activeServiceCandidate.booking_candidate.first_name &&
      !this.activeServiceCandidate.booking_candidate.last_name
    ) {
      return null;
    }
    return (
      (this.activeServiceCandidate.booking_candidate.first_name ?? '') +
      ' ' +
      (this.activeServiceCandidate.booking_candidate.last_name ?? '')
    );
  }

  get canShowResult() {
    if (
      this.activeServiceCandidate.booking_candidate.status &&
      [this.bookingCandidateStatuses.STATUS_COMPLETED.key].includes(
        this.activeServiceCandidate.booking_candidate.status
      )
    ) {
      return true;
    }
    return false;
  }

  toDownloadReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadReport',
        this.questionnaireAnswer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.candidateName;
        link.click();
      });
  }

  async complete() {
    this.isLoading = true;
    this.showResult = false;
    this.showComment = false;
    this.showConfirm = false;
    const responseOK = await this.comment();

    // if previous comments action failed stop here
    if (!responseOK) {
      return;
    }

    this.$store
      .dispatch('ServiceCandidate/complete', this.tmpServiceCandidate)
      .then(() => {
        this.init();
      })
      .catch(({ response }) => {
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: response.data.error,
        });
        this.isLoading = false;
      });
  }

  toggleComment() {
    this.showComment = !this.showComment;
  }

  close() {
    this.showResult = this.showComment = false;
  }

  validateComplete() {
    this.commentInvalid = false;
    const { is_empty, signature_image } = this.qUserSignature.getSignature();
    if (
      is_empty ||
      _.isEmpty(this.tmpServiceCandidate.service_comment.comment)
    ) {
      this.commentInvalid = true;
      return;
    } else {
      this.showConfirm = true;
      this.tmpServiceCandidate.service_comment.signature_image = signature_image;
    }
  }

  get businessContact() {
    if (
      !_.isEmpty(
        this.activeServiceCandidate.service_request.business.primary_contact
      )
    ) {
      return this.activeServiceCandidate.service_request.business
        .primary_contact;
    }

    if (
      !_.isEmpty(
        this.activeServiceCandidate.service_request.business.business_contacts
      )
    ) {
      return this.activeServiceCandidate.service_request.business
        .business_contacts[0];
    }

    return null;
  }
}
